export const COOKIE_SETTING_KEY = 'cookie.setting';
